/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { WidgetComponent } from "../../Widget";
import { decodeCustomCode } from "../../../../utils/decodeCustomCode";

function CustomWidgetRow({ metadata }) {
  const codeToInject = get(metadata, ["config", "customCode"], "");
  return <WidgetComponent widgetValue={`<div>${decodeCustomCode(codeToInject)}</div>`} />;
}

CustomWidgetRow.propTypes = {
  metadata: PropTypes.object
};
export { CustomWidgetRow };
